var paragraph_default = {
  "fontElementMap": "aNRFJ",
  "elementSpacing": "nLZjf",
  "text": "NbiCH nLZjf",
  "child": "d3UxR"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
